import { post} from './http'
// import qs from 'qs'

//请求用户
export function requestUser(openId) {
    return post('/tyapi/pc/venueOrder/requestUser', {
        "openId": openId,
    })
}

//保存用户
export function saveUser(name,phone,openId) {
    return post('/tyapi/pc/venueOrder/saveUser', {
        "name": name,
        "phone": phone,
        "openId": openId
    })
}

//获取场馆介绍列表
export function getVenueProfileList() {
    return post('/tyapi/pc/venueOrder/getVenueProfileList', {
    })
}

//获取场馆选项信息
export function getOptions() {
    return post('/tyapi/pc/venueOrder/getOptions', {
    })
}

//获取场馆预约详情
export function getVenueOrderOpen(date,areaId) {
    return post('/tyapi/pc/venueOrder/getVenueOrderOpen', {
        "date": date,
        "areaId": areaId
    })
}

//提交预约
export function commitConference(orderOpenId,userId) {
    return post('/tyapi/pc/venueOrder/commitConference', {
        "orderOpenId": orderOpenId,
        "userId": userId
    })
}

//获取当前预约信息
export function getCurrConference(conferenceId) {
    return post('/tyapi/pc/venueOrder/getCurrConference', {
        "conferenceId": conferenceId
    })
}

//付款
export function payment(conferenceId,companionIds) {
    return post('/tyapi/pc/venueOrder/payment', {
        "conferenceId": conferenceId,
        "companionIds":companionIds
    })
}

//获取预约结果
export function getConferenceResult(conferenceId) {
    return post('/tyapi/pc/venueOrder/getConferenceResult', {
        "conferenceId": conferenceId
    })
}

//我的预约
export function getMyConference(page,pageSize,userId,searchWord) {
    return post('/tyapi/pc/venueOrder/getMyConference', {
        "page": page,
        "pageSize": pageSize,
        "userId": userId,
        "searchWord":searchWord
    })
}

//取消预约
export function removeConference(conferenceId) {
    return post('/tyapi/pc/venueOrder/removeConference', {
        "conferenceId": conferenceId
    })
}

//预约退费
export function refund(conferenceId,reason) {
    return post('/tyapi/pc/venueOrder/refund', {
        "conferenceId": conferenceId,
        "reason": reason
    })
}

//获取场馆介绍
export function getVenueProfile(venueId) {
    return post('/tyapi/pc/venueOrder/getVenueProfile', {
        "venueId": venueId
    })
}

//获取用户信息
export function getUser(userId) {
    return post('/tyapi/pc/venueOrder/getUser', {
        "userId": userId
    })
}

//编辑用户信息
export function edit(userId,name,phone) {
    return post('/tyapi/pc/venueOrder/edit', {
        "userId": userId,
        "name": name,
        "phone": phone
    })
}

//上传头像
export function upload(userId,file) {
    return post('/tyapi/pc/venueOrder/upload', {
        "userId": userId,
        "file":file,
    })
}

//获取同伴列表
export function getPartnerList(userId) {
    return post('/tyapi/pc/venueOrder/getPartnerList', {
        "userId": userId
    })
}

//搜索同伴
export function searchPartner(searchWord) {
    return post('/tyapi/pc/venueOrder/searchPartner', {
        "searchWord": searchWord
    })
}

//添加同伴 partnerId:所选择要添加为同伴的用户id
export function addPartner(userId,partnerId) {
    return post('/tyapi/pc/venueOrder/addPartner', {
        "userId": userId,
        "partnerId": partnerId
    })
}

//删除同伴
export function delPartner(companionId) {
    return post('/tyapi/pc/venueOrder/delPartner', {
        "companionId": companionId
    })
}

//获取预约详情
export function getConferenceInfo(conferenceId) {
    return post('/tyapi/pc/venueOrder/getConferenceInfo', {
        "conferenceId": conferenceId
    })
}

//获取预约须知
export function getInstructionsBook() {
    return post('/tyapi/pc/venueOrder/getInstructionsBook', {})
}

//获取场地实况
export function getVenueFacts() {
    return post('/tyapi/pc/venueOrder/getVenueFacts', {})
}

//删除订单
export function removeOrder(conferenceId) {
    return post('/tyapi/pc/venueOrder/removeOrder', {
        "conferenceId": conferenceId
    })
}

//获取取消预约原因列表
export function getReasons() {
    return post('/tyapi/pc/venueOrder/getReasons', {
    })
}

//获取发票模版
export function getInvoiceTemplate(userId) {
    return post('/tyapi/pc/venueOrder/getInvoiceTemplate', {
        "userId":userId
    })
}

//保存发票模版
export function saveInvoiceTemplate(userId,companyTitle,dutyParagraph,email) {
    return post('/tyapi/pc/venueOrder/saveInvoiceTemplate', {
        "userId":userId,
        "companyTitle":companyTitle,
        "dutyParagraph":dutyParagraph,
        "email":email
    })
}

//开票
export function saveInvoice(userId,conferenceId,companyTitle,personTitle,dutyParagraph,email,invoiceType) {
    return post('/tyapi/pc/venueOrder/saveInvoice', {
        "userId":userId,
        "conferenceId":conferenceId,
        "companyTitle":companyTitle,
        "personTitle":personTitle,
        "dutyParagraph":dutyParagraph,
        "email":email,
        "invoiceType":invoiceType
    })
}

//获取发票信息
export function getInvoice(userId,conferenceId) {
    return post('/tyapi/pc/venueOrder/getInvoice', {
        "userId":userId,
        "conferenceId":conferenceId
    })
}